{
  "Menu": "Menú",
  "Home": "Menú principal",
  "Browse": "Biblioteca de proyectos",
  "howitworks": "Cómo funciona",
  "5DayChallenge": "Desafío de 5 días",
  "logBackIn": "Iniciar sesión",
  "logOut": "Salir",
  "signUpFree": "Regístrate gratis",
  "Login": "Iniciar sesión",
  "Signup": "Regístrate",
  "DashBoard": "Panel de control",
  "ConfirmLeavingPage": "¿Estás seguro de que quieres salir de esta página sin guardar?",
  "CreateProject": "Crea un proyecto",
  "MyEvents": "Eventos",
  "Search": "Buscar",
  "More": "Más",
  "Notifications": "Notificaciones",
  "settings": "Ajustes",
  "help": "Ayuda",
  "SelectProject": "Seleccionar Proyecto",
  "CreateNewProject": "Crear un nuevo proyecto",
  "NewProject": "Nuevo Proyecto",
  "NoGoBack": "No, vuelve",
  "YesClose": "Si, cerrar",
  "ProjectPage": "Tu proyecto",
  "Builders": "Builders",
  "HubLibrary": "Biblioteca",
  "Team": "Equipo",
  "addToTeam": "Añadir al equipo",
  "homeMenu": "Menú principal",
  "Activities": "Muro",
  "Admin": "Administrador",
  "AllMyEvents": "Mis Eventos",
  "Brain": "Brain",
  "Cancel": "Cancelar",
  "FirstChoice": "Contacta con nosotros",
  "Groups": "Grupos",
  "Hub": "Centro",
  "Events": "Eventos",
  "Members": "Comunidad",
  "Project": "Proyecto",
  "ProjectBuilders": "Tus builders",
  "ProjectAndBuilders": "Proyecto y Builders",
  "HubOrEvents": "Hub o Eventos",
  "Projects": "Proyectos",
  "SubscriptionExpired": "¡Esta suscripción ha caducado!",
  "SubscriptionExpiredMessage": "Tu acceso al hub ahora es limitado. Por favor renueve poniéndose en contacto con nosotros.",
  "addProject": "añadir proyecto",
  "addTeammate": "añadir miembro al equipo",
  "change": "cambiar",
  "changeDefaultProject": "cambiar proyecto predeterminado",
  "currentDefault": "Predeterminado Actual",
  "defaultProjectNote": "Su proyecto predeterminado aparecerá en la parte superior de la barra de navegación y se abrirá automáticamente para facilitar el acceso.",
  "hideMenu": "ocultar menú",
  "switchTo": "cambiar a",

  "forInnovotors": "Para los Innovadores",
  "contactSales": "Solicita una Demo",

  "forOrganizations": "Para organizaciones",
  "forEducators": "Para educadores",
  "about": "Sobre RebelBase",
  "SeeAll": "Ver todo",
  "blog": "Blog",

  "Language": "Idioma",
  "Brain": "Cerebro"
}
